import '~/assets/scss/trust-management.scss'

import getSwiperSlider from '~/js/modules/slider'
import Accordion from '~/js/modules/accordion';

window.addEventListener(`DOMContentLoaded`, () => {
  const accordions = document.querySelectorAll(`.accordion`);
  
  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "center", behavior: "smooth" });
    });
  });

  const stagesSlider = document.querySelector(`.js-stages-slider`)
  if (stagesSlider) {
    const stagesSwiperParams = {
      speed: 1000,
      slidesPerView: 1.3,
      loop: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      touchStartForcePreventDefault: true,
      centeredSlides: false,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      spaceBetween: 0,
      navigation: {
        enabled: false
      },
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        forceToAxis: true
      }
    }
    const swiper = getSwiperSlider(stagesSlider, stagesSwiperParams)
  }
  
  const legalForm = document.querySelector(`.js-form-trust-management`);
  if(legalForm) {
    legalForm.addEventListener('submit', function () {
      const y = document.querySelector(`#form-contact`).getBoundingClientRect().top + window.pageYOffset - 128;
      window.scrollTo({ top: y, behavior: 'smooth' });
    })
  }
})